<template>
	<div class="pc-errors pc-box box box--danger" v-if="Object.keys(errors).length > 0">
		<div class="box__subtitle"><i class="box__icon material-icons">error_outline</i>Please fix fields error before proceeding to next step</div>
		<div class="callout callout--danger" v-for="(error, index) in errors" :key="index">
			<div class="callout__content" v-html="sanitizeHtml(error)"></div>
		</div>
	</div>
</template>

<script>
import { sanitizeHtml } from '@/lib/helper';

export default {
	name: 'errors',
	props: ['errors'],
	methods: {
		sanitizeHtml,
	},
};
</script>
